import { FleekError } from './FleekError';

type FleekConfigMissingFileErrorOptions = {
  configPath?: string;
};

export class FleekConfigMissingFileError extends FleekError<FleekConfigMissingFileErrorOptions> {
  public name = 'FleekConfigMissingFileError';

  toString = () => {
    return `Unable to access or find the configuration file${(this.data.configPath && ' ' + this.data.configPath + '.') || '.'}`;
  };
}
